import { makeStyles } from '@rbx/ui';

/**
 * Styles for TryItOutContainer component
 * Extracted from OperationDetails.styles.ts for Try It Out controls
 */
const useTryItOutContainerStyles = makeStyles()((theme) => ({
  tryItOutControls: {
    marginBottom: '8px',
  },

  tryItOutHeader: {
    paddingBottom: '8px',
    borderBottom: `1px solid ${theme.palette.components.divider}`,
  },
}));

export default useTryItOutContainerStyles;
